import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { LanguageLoader } from "../../assets/languages";
import Select from "react-select";
import { ReactSelectOptions } from "../utils";

const Dropdown = ({defaultValue, multiple, options, onChange, disabled}) =>
{
	const settings = useSelector((state) => state.settings);
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	options = ReactSelectOptions(options);
	const [value, SetValue] = useState(multiple ? [] : options?.[0]?.value ?? "");
	const [firstLoad, SetFirstLoad] = useState(true);

	useEffect(() =>
	{
		if(defaultValue && defaultValue.length && firstLoad)
		{
			SetValue(defaultValue);
			onChange(defaultValue);
			SetFirstLoad(false);
		}
	// eslint-disable-next-line
	}, [defaultValue]);
	
	const HandleChange = (dropdownValue) =>
	{
		// SetValue(dropdownValue);
		let finalValue;
		if(multiple)
		{
			finalValue = [];
			for(const item of dropdownValue)
			{
				finalValue.push(item.value);
			}
		}
		else
		{
			// When the value is 0 and the label is empty, it indicates that this value has been sorted by our code.
			finalValue = (dropdownValue.value === "0" && dropdownValue.label === "") ? "" : dropdownValue.value;
		}
		SetValue(finalValue);
		if(onChange)
		{
			onChange(finalValue);
		}
	}
	return <Select
		value={(multiple && value.length) ? options.filter((option) => value.includes(option.value)) : options.find((option) => option.value === value)}
		onChange={(selectedOption) => HandleChange(selectedOption)}
		placeholder={language.COMPONENTS.SELECT_OPTION_PLACEHOLDER}
		options={options}
		defaultValue={!multiple ? options[0] : null}
		isClearable={false}
		menuPlacement="auto"
		className={settings.strings.dropdown_container}
		classNamePrefix={settings.strings.dropdown_prefix}
		isDisabled={disabled}
		isMulti={multiple}
	/>
}

export default Dropdown;